<template lang="pug">
  .h-100.w-100.position-absolute
    #map-search-condition.position-absolute.m-2.shadow-sm
      .input-group
        input#search-text.form-control(type="text" placeholder="キーワード" @keydown.enter="searchRockyList")
        .input-group-append
          button#search-button.input-group-text(@click.prevent="searchRockyList")
            i.fa.fa-search
      //-検索結果
      #searchResult.bg-light
    //-登攀スタイル
    #style-condition.position-absolute.pt-3
      //-モバイル
      .btn-group-mobile.btn-group-vertical(role="group" aria-label="登攀スタイル")
        button.btn.btn-light#style-all(type="button" v-bind:class="{styleActive:isStyleAll}" @click.prevent="changeStyle('all')" ) 全て
        button.btn.btn-light#style-bl(type="button" v-bind:class="{styleActive:isStyleBl}" @click.prevent="changeStyle('bl')") ボルダー
        button.btn.btn-light#style-rc(type="button" v-bind:class="{styleActive:isStyleRc}" @click.prevent="changeStyle('rc')") ロープ
      //-PC
      .btn-group(role="group" aria-label="登攀スタイル")
        button.btn.btn-light#style-all(type="button" v-bind:class="{styleActive:isStyleAll}" @click.prevent="changeStyle('all')" ) 全て
        button.btn.btn-light#style-bl(type="button" v-bind:class="{styleActive:isStyleBl}" @click.prevent="changeStyle('bl')") ボルダー
        button.btn.btn-light#style-rc(type="button" v-bind:class="{styleActive:isStyleRc}" @click.prevent="changeStyle('rc')") ロープ
    //-拡大表示ボタン
    .position-absolute#expand-button(v-if="isCustumExpandCtlShow")
      button(@click.prevent="mapExpand")
        //-広げるマークと閉じるマーク
        i.fas(v-bind:class="[isExpanded === true ? 'fa-compress-arrows-alt' : 'fa-expand-arrows-alt']")
    //-岩場ダイアログ
    #mapRockyDrawer(v-if="isDispMapRockyDrawer" v-bind:style="{position : mapRockyDrawerPosition}")
      #mapRockyDrawer-inner
        #rocky-img
          #rocky-img-inner
            img(:src="makeImgPath(drawerRockyImgPath)" :alt="drawerRockyName")
            #pc-close-button
              i.fas.fa-times(@click.prevent="closeMapRockyDrawer")
        #detail
          #rockyNameKana {{drawerRockyNameKana}}
          #top.d-flex
            #rocky-name 
              a(@click="callRockyInfoFromDialog(drawerRockyId)") {{drawerRockyName}}
            #close-button
              i.fas.fa-times(@click.prevent="closeMapRockyDrawer")
          #place {{drawerRockyPlace}}
    //- Map表示
    #map.h-100
</template>

<script>
import axios from 'axios'
var scriptjs = require("scriptjs")

export default {
  // 呼び出し元から受け取るプロパティ
  props: {
    //初期位置(デフォルトの中心地点は関東あたり)
    lat: {type: Number,default: 36.180669},
    lng: {type: Number,default: 138.651111},
    zoom: {type: Number,default: 6},
    gestureHandling:{type: String, default: 'cooperative'},
    isCustumExpandCtlShow: {type: Boolean,default:false},
  },
  data() {
    return {
      isDispMapRockyDrawer: false,
      fullscreenControl:false,
      // デフォルト値
      map: null,
      // 表示エリアの自動調整用object
      bounds:null,
      // TOP画面のマーカークラスター用
      markerClusterer:null,
      //マーカーオブジェクトのList
      rockyMarkerList:[],//岩場
      // 表示中のInfowindowを保持
      currentInfoWindow:null,
      // マーカーのアイコン
      ROCKY_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-rock.png',
      ROCKY_SELECTED_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-rock-selected.png',
      MY_LOCATION_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/my_location_point.png',
      // フラグ制御に使用
      FLG_ROCKY:'rocky',
      // クラスターのアイコン
      CLUSTERER_IMG_PATH:'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      // MAP上に表示するドロワーの値
      drawerRockyId: 0,
      drawerRockyName: '',
      drawerRockyNameKana: '',
      drawerRockyPlace: '',
      drawerRockyImgPath: '',
      isExpanded:false,
      isMyLocationShow:false,
      activeMarkerId: '',
      // 登攀スタイル
      isStyleAll:true,
      isStyleBl:false,
      isStyleRc:false,
      mapRockyDrawerPosition : 'absolute',
      isRockyMapSearch : false,
      // ラベルボタン
      labelBtnStyle: "color: gray;",
      isLabelShow: false,
      LABEL_SHOW_LEVEL: 15,
      LABEL_HIDE_LEVEL: 14,
      // 現在地保持用
      currentLocation: null
    }
  },
  watch:{
    //Mapのフルスクリーンの状態をwatchする
    'isExpanded' (to, from) {
      if(this.isExpanded && window.innerWidth < 416 ){
        this.mapRockyDrawerPosition = 'fixed'
      }else{
        this.mapRockyDrawerPosition = 'absolute'
      }
    }
  },
  created() {
    // console.log('Mapコンポーネントのcreated')
    //GoogleMapAPI呼び出し
    scriptjs(
      'https://maps.googleapis.com/maps/api/js?key=' + process.env.VUE_APP_GOOGLE_MAPS_API_KEY + '&libraries=geometry&region=JP&language=ja',
      'loadGoogleMap'
    )
    //マップロード処理
    scriptjs.ready("loadGoogleMap", this.loadMap)

    //Map検索画面の場合は初期表示から最大化されているので、フラグをセットする。
    if(this.$route.name == 'rocky_map_search'){
      this.isExpanded = true
      this.isRockyMapSearch = true

      if(window.innerWidth < 416){
        this.mapRockyDrawerPosition = 'fixed'
      }
    }

    //ブラウザバックの検知を追加
    window.history.pushState(null, null, null);
    window.addEventListener("popstate", this.popstateProcess)

  },
  mounted() {
    // console.log('Mapコンポーネントのmounted')
    this.$nextTick(() => {
      // ビュー全体がレンダリングされた後にのみ実行されるコード
      // console.log('MapコンポーネントのnextTick')
    })
  },
  // データ変更後
  updated() {
    // console.log('Mapコンポーネントのupdated')
  },
  // インスタンス破棄前
  beforeDestroy() {
    // ブラウザバックイベントを解除
    window.removeEventListener("popstate", this.popstateProcess)
  },
  // メソッド
  methods: {
    //-------------------------------------
    // MAPのロード処理(TOP画面、地図検索画面)
    //-------------------------------------
    async loadMap() {

      //岩場情報JSON取得
      await this.getRockyMapData()

      //マップ表示用のListにセットする
      let paramList = []
      this.allRockyJsonData.forEach((target) => {
        paramList.push({
          longLat: target.longitudelatitude,
          title: target.name,
          subtitle: target.level,
          containt: target.address,
          url: target.url
        })
      })

      let wkLat = this.lat
      let wkLng = this.lng
      let wkZoom = this.zoom

      //ブラウザバックした際に前回の中央位置とzoomを再現する。
      if(localStorage.isLastMapCentervalid == 'true'){
        wkLat = Number(localStorage.mapCenterLat)
        wkLng = Number(localStorage.mapCenterLng)
        wkZoom = Number(localStorage.mapCenterZoom)
      }

      //mapオブジェクト作成
      //console.log('new google.maps.Map()')
      this.map = new google.maps.Map(document.getElementById("map"), {
        //中心座標
        center: { lat: wkLat, lng: wkLng },
        //zoom
        zoom: wkZoom,
        //スクロール設定
        gestureHandling: this.gestureHandling, //スクロール設定
        //マップタイプ(地図、航空写真) コントロール
        mapTypeControl: false, 
        //全画面表示コントロール
        fullscreenControl: false, 
        //ストリートビュー コントロール
        streetViewControl: false, 
        //ズーム コントロール
        zoomControl: false 
      })

      //this.bounds初期化
      this.initBoundsList()

      //検索コントロールを配置
      this.makeSearchControl()

      //現在位置表示ボタンを配置
      this.makeMyLocationControl()
      // ラベル切り替えボタンを配置
      this.makeMyLabelControl()

      //マーカー作成
      this.addRockyMarker(paramList,true,false,false)

      // googleMap上のズーム変更のイベントリスナー
      google.maps.event.addListener(this.map, "zoom_changed", async() => {
        const level = this.map.getZoom()
        if(level >= this.LABEL_SHOW_LEVEL && !this.isLabelShow) {
          await this.switchLabel()
          this.changeRockyMarkerActive(this.activeMarkerId)
        }else if(level == this.LABEL_HIDE_LEVEL){
          this.isLabelShow = true
          await this.switchLabel()
          this.changeRockyMarkerActive(this.activeMarkerId)
        }
      })
    },
    //----------------------------------------
    // 地図上のラベルの表示を切り替える
    //----------------------------------------
    async switchLabel() {
      await this.deletAllMarker()
      this.isLabelShow = this.isLabelShow ? false : true
      let style = "all"
      if(this.isStyleAll) {
        style = "all"
      } else if(this.isStyleBl) {
        style = "bl"
      } else if(this.isStyleRc){
        style = "rc"
      }
      await this.changeStyle(style)
      this.makeMyLabelControl()

    },
    //----------------------------------------
    // マーカーを選択状態に変更する
    //----------------------------------------
    changeRockyMarkerActive(markerId) {
      try{
        // アクティブマーカーを抽出する
        const markers = this.rockyMarkerList.filter(n => n.id == markerId)
        markers[0].setIcon(new google.maps.MarkerImage(this.ROCKY_SELECTED_ICON))
        markers[0].icon.labelOrigin = new google.maps.Point(10, 40);
        this.openmapRockyDrawer(markerId)
      } catch(err) {
        console.log("changeRockyMarkerActive", err)
      }
    },
    //----------------------------------------
    // 岩場マーカーの作成(TOPページから呼ばれる)
    //----------------------------------------
    addRockyMarker(paramList,isUseMarkerClusterer,isFitBounds,isMapPinStabilization){

      //マーカー追加
      this.addMarker(paramList,false,this.ROCKY_ICON,this.FLG_ROCKY,isFitBounds)
      //イベントリスナー設定
      this.rockyMarkerList.forEach((marker) => {
        marker.addListener("click", () => {

          //表示中の岩場マーカーを一旦"未選択"の状態にする
          this.rockyMarkerList.forEach((targetMarker) => {
            targetMarker.setIcon(new google.maps.MarkerImage(this.ROCKY_ICON))
            // 2022/07/07 追加
            targetMarker.icon.labelOrigin = new google.maps.Point(10, 40);
          })
          
          //選択中のマーカーに変更する
          marker.setIcon(new google.maps.MarkerImage(this.ROCKY_SELECTED_ICON))
          // 2022/07/07 追加
          marker.icon.labelOrigin = new google.maps.Point(10, 40);
          //drawerを表示する
          this.openmapRockyDrawer(marker.id)
          // 選択中のマーカーidを保持
          this.activeMarkerId = marker.id
        })
      })

      //MarkerClustererの設定
      //MarkerClusterer()クラスの廃止に伴い、新クラスに移行するまでコメントアウト
      //if(isUseMarkerClusterer){
      //  this.markerClusterer = new MarkerClusterer(
      //                            this.map, 
      //                            this.rockyMarkerList, 
      //                            {maxZoom: 12, 
      //                            imagePath: this.CLUSTERER_IMG_PATH }
      //                          )
      //}

      if(isMapPinStabilization){
        //Map内の岩場検索時、ピンの位置ずれを修正する
        let addLong = 0
        let addLat = 0
        let count = paramList.length

        for (let index = 0; index < count; index++) {
          const element = paramList[index]
          let long = Number(element.longLat.split(',')[1])
          let lat = Number(element.longLat.split(',')[0])

          addLong += long
          addLat += lat
        }

        this.setCenter(addLat/count,addLong/count)
      }

    },
    //---------------------------------------
    // 地図のフルスクリーン表示
    //---------------------------------------
    mapExpand(){

      if(!this.isExpanded){
        //地図を最大表示する
        this.isExpanded = true
        //スクロールモードを変更
        this.map.gestureHandling = 'greedy'
        //親画面側でサイズを変更する
        this.$parent.mapFull()
      }else{
        //元のサイズに戻す
        this.isExpanded = false
        //スクロールモードを変更
        this.map.gestureHandling = 'cooperative'
        //親画面側でサイズを変更する
        this.$parent.mapFullReset()
      }
    },
    //---------------------------------------
    // 現在位置の表示
    //---------------------------------------
    async myLocationShow(){

      let pos
      try {
        //現在位置の座標取得
        pos = await this.getPosition()
        let lat = pos.coords.latitude
        let lng = pos.coords.longitude
        //for debug
        // lat = 35.64724645414717
        // lng = 139.67675525888234

        // マーカーが表示状態なら以前の位置を削除
        if(this.isMyLocationShow && this.currentLocation != null) {
          this.currentLocation.setMap(null);
        }
        //MAPにマーカーを追加する
        let marker = new google.maps.Marker({ 
          //google.maps.Markerの必須項目
          position:new google.maps.LatLng(lat,lng),
          icon: this.MY_LOCATION_ICON,
          map: this.map,
        })
        // 最新の情報を保持
        this.currentLocation = marker
        this.isMyLocationShow = true

        //現在位置をMAPの中心位置にする
        this.setCenter(lat,lng)

      } catch (err) {
        console.log(err)
        await this.asyncDialog('現在地を取得できませんでした。端末、もしくはブラウザの位置情報の許諾に関する設定をご確認ください。')
        return
      }
    },
    //座標取得処理
    getPosition: () => new Promise((resolve, reject) => {
      if (!navigator || !navigator.geolocation) reject()
      navigator.geolocation.getCurrentPosition(
        pos => resolve(pos),
        err => reject(err),
        {
          enableHighAccuracy: true,
          //maximumAge: 300000,  // 5分前まで
          maximumAge: 0,
          timeout: 5000
        }
      )
    }),
    //------------------------------
    // MAP上のマーカー作成
    //------------------------------
    addMarker(paramList,isUseAnimation,iconPath,markerType,isFitBounds){

      switch(markerType) {
        //岩場
        case this.FLG_ROCKY:
          this.rockyMarkerList = []  
          break;
      }

      //this.bounds初期化
      this.initBoundsList()

      paramList.forEach((target) => {

        //マーカーオブジェクトを生成
        let marker = this.makeMarkerObject(
                      target.longLat,
                      isUseAnimation,
                      iconPath,
                      target.url,
                      target.title,
                      target.contentString)

        //MAPの表示エリア調整用のListに追加する
        let retrnArray = this.splitLngLat(target.longLat)
        this.bounds.extend(new google.maps.LatLng(retrnArray[0], retrnArray[1]))

        switch(markerType) {
          //岩場
          case this.FLG_ROCKY:
            this.rockyMarkerList.push(marker) 
            break;
        }

        //MAPの表示エリアを調整する
        if(isFitBounds){
          this.map.fitBounds(this.bounds)
        }
      })

    },
    //----------------------
    //Markerオブジェクト作成
    //----------------------
    makeMarkerObject(latlng,isAnimation,iconPath,id,name,contentString){

      //経度緯度を分割
      let retrnArray = this.splitLngLat(latlng)
      let lat = retrnArray[0]
      let lng = retrnArray[1]

      // 2022/07/07 追加
      const label = {
        text: name,
        fontFamily: 'sans-serif',
        color: 'black',
        fontWeight: 'bold',
        fontSize: '12px',
        className: 'maplabel'
      }

      let wkObj = {
        //google.maps.Markerの必須項目
        position:new google.maps.LatLng(lat,lng),
        icon: {
          url: iconPath,
          // 2022/07/07 追加
          labelOrigin: new google.maps.Point(10, 40)
        },
        map: this.map,
        //独自設定項目
        id: id,
        name: name,
        contentString: contentString,
      }
      // ラベルプロパティを追加
      if(this.isLabelShow) {
        wkObj.label = label
      }

      //アニメーション有りの場合
      if(isAnimation){
        // 上部から1度落ちてくるアニメーションを追加する
        wkObj.animation = google.maps.Animation.DROP
      }

      return new google.maps.Marker(wkObj)
    }, 
    splitLngLat(str){
      //経度緯度を分割
      var rockyLongLat = {}
      try {
        rockyLongLat = str.split(',')
      } catch(err) {  
        //TODO:システムエラーにするか検討
        return null
      } 

      let lat = parseFloat(rockyLongLat[0])
      let lng = parseFloat(rockyLongLat[1])
      let retrnArray = [lat,lng]
    
      return retrnArray
    },
    initBoundsList(){
      this.bounds = new google.maps.LatLngBounds()
      //常に岩場中心のマーカーが範囲に含まれるようListに追加する
      this.bounds.extend(new google.maps.LatLng(this.lat, this.lng))
    },
    extendBoundsList(lnglat){
      let retrnArray = this.splitLngLat(lnglat)
      this.bounds.extend(new google.maps.LatLng(retrnArray[0], retrnArray[1]))
    },
    openmapRockyDrawer(rockyId){

      //岩場JSONの情報を抽出する
      let rockyJson = this.allRockyJsonData.filter(record => record.rockyId == rockyId)[0]
      this.drawerRockyId = rockyId
      this.drawerRockyName = rockyJson.name
      this.drawerRockyNameKana = rockyJson.nameKana
      this.drawerRockyPlace =  rockyJson.address
      this.drawerRockyImgPath = rockyJson.imgPath
      //drawerを表示する
      this.isDispMapRockyDrawer = true
    },
    closeMapRockyDrawer(){
      //drawer閉じる
      this.isDispMapRockyDrawer = false
    },
    //----------------------------
    //地図の中心座標を移動変更する
    //----------------------------
    setCenter(lat,lng){
      const latlng = new google.maps.LatLng(lat, lng)
      this.map.setCenter(latlng)
    },
    //----------------------------
    //岩場情報JSONファイル取得
    //----------------------------
    async getRockyMapData(){
      //岩場情報JSON
      let jsonUrl = process.env.VUE_APP_MATERIAL_URL + '/allRockyList.json'
      await axios
        .get(jsonUrl)
        .then(response => {
          this.allRockyJsonData = response.data
        })
        .catch(function (error) {alert(error)})

      //データが0件の場合
      if(this.allRockyJsonData.length == 0){
        //ここでデータが取得できない場合は、データ不正
        await this.asyncDialog('システムエラー：岩場マップ情報を取得できませんでした')
        return
      }
    },
    asyncDialog(msg) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxOk(msg, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          resolve(value)
        })
        .catch(err => {
          // An error occurred
        })
      })
    },
    //---------------------------------------
    // MAP上に表示（検索コントロール）
    //---------------------------------------
    makeSearchControl(){

      if(document.getElementById("searchControl") != null){
        //既に表示されている場合は何もしない
        return
      }

    },
    //-----------------------------------------------------------
    //テキストボックスに入力値をキーに岩場を検索し、検索結果を表示する
    //-----------------------------------------------------------
    async searchRockyList(){

      //岩場情報ドロワーを非表示にする
      this.isDispMapRockyDrawer = false

      //登攀スタイルの絞込表示をリセットする
      this.isStyleAll = true
      this.isStyleBl = false
      this.isStyleRc = false

      //検索結果表示エリアを表示する
      let ekEl = document.getElementById('searchResult')
      ekEl.style.display = 'block'

      //テキストボックスの入力値
      let textBoxUI = document.getElementById('search-text')
      let keyword = textBoxUI.value
      //岩場をキーワードで絞込する
      let wkList = this.allRockyJsonData.filter(record => record.name.match(keyword))
      //検索結果を表示する
      if(wkList.length == 0){
        ekEl.style.fontSize = '10px'
        ekEl.innerHTML = '<b>該当する岩場は存在しません。</b>'
        return
      }else{
        ekEl.style.fontSize = '13px'
        ekEl.innerHTML = '&nbsp &nbsp<b>' +  wkList.length + '件</b> 該当しました。'
      }

      //マップ表示用のListにセットする
      let paramList = []
      wkList.forEach((target) => {
        paramList.push({
          longLat: target.longitudelatitude,
          title: target.name,
          subtitle: target.level,
          containt: target.address,
          url: target.url
        })
      })

      //表示中のマーカーを全て消す
      await this.deletAllMarker()

      //this.bounds初期化
      this.initBoundsList()

      //マーカー作成
      this.addRockyMarker(paramList,true,true,true)



    },
    //-----------------------------------------------------------
    //登攀スタイルの絞込
    //-----------------------------------------------------------
    async changeStyle(style){

      //キーワード検索と登攀スタイル絞込は連動させない。
      //キーワード検索関連の項目をクリアする
      //岩場情報ドロワーを非表示にする
      this.isDispMapRockyDrawer = false

      //検索結果表示エリアを表示する
      let ekEl = document.getElementById('searchResult')
      ekEl.style.display = 'none'

      //テキストボックスの入力値
      let textBoxUI = document.getElementById('search-text')
      textBoxUI.value = ""

      //対象のスタイルをアクティブにする
      this.isStyleAll = style == 'all' ? true : false
      this.isStyleBl = style == 'bl' ? true : false
      this.isStyleRc = style == 'rc' ? true : false

      //岩場情報ドロワーを非表示にする
      this.isDispMapRockyDrawer = false

      let wkList = this.allRockyJsonData

      if(style != 'all'){
        //岩場をスタイルで絞込する
        wkList = this.allRockyJsonData.filter(record => record.climbingStyleCd.match(style) || record.climbingStyleCd=='both')
      }

      //マップ表示用のListにセットする
      let paramList = []
      wkList.forEach((target) => {
        paramList.push({
          longLat: target.longitudelatitude,
          title: target.name,
          subtitle: target.level,
          containt: target.address,
          url: target.url
        })
      })

      //表示中のマーカーを全て消す
      await this.deletAllMarker()

      //this.bounds初期化
      this.initBoundsList()

      //マーカー作成
      this.addRockyMarker(paramList,true,false,false)

    },
    //表示中の全てのマーカーを削除する
    async deletAllMarker(){
      //岩場マーカー削除
      this.rockyMarkerList.forEach(function (marker, idx) { marker.setMap(null) })
      //マーカークラスター削除
      if(this.markerClusterer){
        this.markerClusterer.clearMarkers()
      }
    },
    //---------------------------------------
    //現在位置表示ボタン
    //---------------------------------------
    makeMyLocationControl(){

      if(document.getElementById("myLocationControl")){
        //既に表示されている場合は何もしない
        return
      }

      var btnDiv = document.createElement('div')
      btnDiv.id = 'myLocationControl'

      //岩場に戻る
      var myLocationBtn = document.createElement('div')

      //地図拡大ボタンの表示(google標準or独自実装)によってstyleを分ける
      if(this.isCustumExpandCtlShow){
        //独自実装の拡大ボタンの場合
        myLocationBtn.style.width = '38px'
        myLocationBtn.style.height = '38px'
        myLocationBtn.style.margin = '55px 1.5rem 10px 10px'
        myLocationBtn.style.borderRadius = '3px'
        myLocationBtn.style.color = 'rgb(170, 170, 170)'
      }else{
        myLocationBtn.style.width = '40px'
        myLocationBtn.style.height = '40px'
        myLocationBtn.style.margin = '0 10px 10px 10px'
        if(this.$route.path == '/rocky/map_search'){
          myLocationBtn.style.margin = '10px 10px 10px 10px'
        }
        myLocationBtn.style.borderRadius = '2px'
        myLocationBtn.style.color = '#666666'
      }

      myLocationBtn.style.backgroundColor = '#FFFFFF'
      myLocationBtn.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px'
      myLocationBtn.style.border = '1px solid #cfd3d7'
      myLocationBtn.style.cursor = 'pointer'
      myLocationBtn.style.display = 'flex'
      myLocationBtn.style.justifyContent = 'center'
      myLocationBtn.style.alignItems = 'center'
      myLocationBtn.title = '現在地'
      btnDiv.appendChild(myLocationBtn)

      var myLocationBtnText = document.createElement('div')
      myLocationBtnText.style.paddingTop = '4px'
      myLocationBtnText.innerHTML = '<b><i class="material-icons">my_location</i></b>'
      myLocationBtn.appendChild(myLocationBtnText)

      btnDiv.index = 2
      /* カスタムコントロールを地図の左上に配置 */
      this.map.controls[google.maps.ControlPosition.RIGHT].push(btnDiv)

      //ボタン押下のイベントリスナー
      google.maps.event.addDomListener(myLocationBtn, "click", () => {
        //現在地を表示する
        this.myLocationShow()
      })
    },
    //---------------------------------------
    //地図ラベル切り替えボタン
    //---------------------------------------
    makeMyLabelControl(){
      // 既に表示されている場合はテキストカラーを変化させる
      if(document.getElementById("myLabelControl")){
        var labelControl = document.getElementById("myLabelControl")
        var c = labelControl.firstChild
        var text = c.firstChild
        text.style.color = this.isLabelShow ? 'black' : 'gray'
        return
      }

      var btnDiv = document.createElement('div')
      btnDiv.id = 'myLabelControl'

      //岩場に戻る
      var myLabelBtn = document.createElement('div')

      //地図拡大ボタンの表示(google標準or独自実装)によってstyleを分ける
      if(this.isCustumExpandCtlShow){
        //独自実装の拡大ボタンの場合
        myLabelBtn.style.width = '38px'
        myLabelBtn.style.height = '38px'
        myLabelBtn.style.margin = '1px 1.5rem 10px 10px'
        myLabelBtn.style.borderRadius = '3px'
        myLabelBtn.style.color = 'rgb(170, 170, 170)'
      }else{
        myLabelBtn.style.width = '40px'
        myLabelBtn.style.height = '40px'
        myLabelBtn.style.margin = '0 10px 10px 10px'
        if(this.$route.path == '/rocky/map_search'){
          myLabelBtn.style.margin = '10px 10px 10px 10px'
        }
        myLabelBtn.style.borderRadius = '2px'
        myLabelBtn.style.color = '#666666'
      }

      myLabelBtn.style.backgroundColor = '#FFFFFF'
      myLabelBtn.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px'
      myLabelBtn.style.border = '1px solid #cfd3d7'
      myLabelBtn.style.cursor = 'pointer'
      myLabelBtn.style.display = 'flex'
      myLabelBtn.style.justifyContent = 'center'
      myLabelBtn.style.alignItems = 'center'
      myLabelBtn.title = 'ラベル'
      btnDiv.appendChild(myLabelBtn)

      var myLabelBtnText = document.createElement('div')
      myLabelBtnText.style.paddingTop = '4px'
      myLabelBtnText.innerHTML = '<i class="fa fa-font"></i>'
      myLabelBtnText.style.color = this.isLabelShow ? 'black' : 'gray'
      myLabelBtn.appendChild(myLabelBtnText)

      btnDiv.index = 3
      /* カスタムコントロールを地図の左上に配置 */
      this.map.controls[google.maps.ControlPosition.RIGHT].push(btnDiv)

      //ボタン押下のイベントリスナー
      google.maps.event.addDomListener(myLabelBtn, "click", async () => {
        // ラベルを表示する
        // 一定倍率以上のZoomでも表示される
        await this.switchLabel()
      })
    },
    callRockyInfoFromDialog(rockyId){
      //TOP画面のMAPの中央位置とzoomの保持を有効にする
      localStorage.isLastMapCentervalid = true
      //ローカルストレージに座標情報とzoomの値をセットする
      localStorage.mapCenterLat = Math.floor( this.map.getCenter().lat() * Math.pow( 10, 6 ) ) / Math.pow( 10, 6 )
      localStorage.mapCenterLng = Math.floor( this.map.getCenter().lng() * Math.pow( 10, 6 ) ) / Math.pow( 10, 6 )
      localStorage.mapCenterZoom = this.map.getZoom()
      this.$router.push('/rockyInfo/' + rockyId)
    },
    makeImgPath(imgPath){
      return this.getRockyThumbPath(imgPath,'360')
    },
    popstateProcess(){
      if(this.isExpanded){
        this.mapExpand()
        window.history.pushState(null, null, null);
        return
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

#map
  width 100%

#map-search-condition
  z-index 1
  max-width 200px

#style-condition
  z-index 1
  top 50px
  left 10px
  max-width 200px
  .btn-group-mobile
    .btn-light
      font-size 0.8rem
    .styleActive
      background #98a1a8
      color #FFFFFF
  .btn-group
    display none

#expand-button
  z-index 1
  top 0
  right 1.5rem !important
  font-size 0.5rem
  padding-top 0.5rem 

  button
    width 38px
    height 38px
    padding 0 0.5rem
    border-radius 3px
    font-size 1.2rem
    color rgb(170, 170, 170)
    background #FFF
    box-shadow rgba(0, 0, 0, 0.3) 0px 1px 4px -1px
    border solid 1px #ced4da !important

#mapRockyDrawer
  z-index 1
  //positionはJavaScript側で設定している
  bottom 0
  width 100%
  height 70px
  background #eceeef
  background-color rgba(0, 0, 0, 0.8)
  animation faderight 0.2s ease-in 1
  #mapRockyDrawer-inner
    display flex
    #rocky-img
      width 30%
      height 70px
      #rocky-img-inner
        width 100%
        height 100%
        img
          width 100%
          height 100%
          object-fit cover
        #pc-close-button
          display none
    #detail
      width 70%
      height 70px
      #top
        height 26px
        #rocky-name
          width 85%
          font-size 1rem
          font-weight 600
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          padding 0 0 0 0.5rem
          text-decoration underline
          cursor pointer
          color #f9f9fa
          &:hover
            color #2d8fd5
        #close-button
          width 15%
          padding-top 5px
          color #FFF
          text-align center
          i
            cursor pointer
          &:hover
            color #7f8b93
      #place
        font-size 0.8rem
        height 20px
        color #dee1e3
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        margin-top 0.1rem
        padding-left 0.5rem
      #rockyNameKana
        font-size 0.7rem
        height 20px
        color #dee1e3
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        margin-top 0.1rem
        padding-left 0.5rem
        padding-top 1px

@keyframes faderight
  0%
    width 0px
  100%
    width 200px

// 中デバイス(415px 〜 767px)
@media (min-width: 415px)

  #style-condition
    .btn-group-mobile
      display none
    .btn-group
      max-width 200px
      display block
      .btn
        font-size 13.6px
      .styleActive
        background #98a1a8
        color #FFFFFF
  #mapRockyDrawer

    top 110px
    width 200px
    height 160px   
    margin-left 0.5rem
    #mapRockyDrawer-inner
      display block
      #rocky-img
        width 100%
        height 80px
        #rocky-img-inner
          position relative
          #pc-close-button
            display block
            width 25px
            height 25px 
            position absolute
            top 0
            right 0
            text-align center
            background #cfd3d7
            padding auto
            cursor pointer
      #detail
        width 100%
        height 60px
        #top
          height 30px
          #rocky-name
            padding-left 1rem
            font-size 0.9rem
            height 30px
          #close-button
            display none
        #place
          padding-top 0px
          padding-left 1rem
          font-size 0.8rem
        #rockyNameKana
          padding-top 1px
          padding-left 1rem
          font-size 0.7rem

  @keyframes faderight
    0%
      width 0px
    100%
      width 200px

// PC(768px～)
@media (min-width: 768px)

  #map-search-condition
    .input-group,#searchResult
      max-width 200px

  #mapRockyDrawer
    top 130px
    height 225px
    #mapRockyDrawer-inner
      #rocky-img
        height 140px

</style>
